export default "__VITE_ASSET__0be6e431__"